import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'

class UpdateBloc {

    updateChannel = new Subject()
    updateResponsibilityChannel = new Subject()
    updateAuthorityChannel = new Subject()
    repository = new UpdateRepository()
    detailStankomChannel = new Subject();
    kompetensiChannel = new Subject();
    kompetensiLevelChannel = new Subject();
    positionInfoChannel = new Subject();
    detailTugasChannel = new Subject();
    infoJabatanChannel = new Subject();
    detailTanggungjawabChannel = new Subject();
    detailWewenangChannel = new Subject();
    detailPossesionRequisiteChannel = new Subject();
    updaterequisiteChannel = new Subject();
    detailPengalamanChannel = new Subject();
    detailUpayaChannel = new Subject();
    detailInterestChannel = new Subject();
    detailTrainingChannel = new Subject();

    constructor() {
        this.updateChannel.next({ status: apiResponse.INITIAL })
        this.updateResponsibilityChannel.next({ status: apiResponse.INITIAL })
        this.updateAuthorityChannel.next({ status: apiResponse.INITIAL })
        this.detailStankomChannel.next({status: apiResponse.INITIAL})
        this.kompetensiChannel.next({status: apiResponse.INITIAL})
        this.kompetensiLevelChannel.next({status: apiResponse.INITIAL})
        this.positionInfoChannel.next({status: apiResponse.INITIAL})
        this.detailTugasChannel.next({status: apiResponse.INITIAL})
        this.infoJabatanChannel.next({status: apiResponse.INITIAL})
        this.detailTanggungjawabChannel.next({status: apiResponse.INITIAL})
        this.detailWewenangChannel.next({status: apiResponse.INITIAL})
        this.detailPossesionRequisiteChannel.next({status: apiResponse.INITIAL})
        this.updaterequisiteChannel.next({status: apiResponse.INITIAL})
        this.detailPengalamanChannel.next({status: apiResponse.INITIAL})
        this.detailUpayaChannel.next({status: apiResponse.INITIAL})
        this.detailInterestChannel.next({status: apiResponse.INITIAL})
        this.detailTrainingChannel.next({status: apiResponse.INITIAL})
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdate(query).then((result) => {
                this.updateChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updateChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchUpdateTanggungjawab = async (query) => {
        this.updateResponsibilityChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdateTanggungjawab(query).then((result) => {
                this.updateResponsibilityChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updateResponsibilityChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchUpdateWewenang = async (query) => {
        this.updateAuthorityChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdateWewenang(query).then((result) => {
                this.updateAuthorityChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updateAuthorityChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchUpdateSyaratJabatan = async (query) => {
        this.updaterequisiteChannel.next({ status: apiResponse.LOADING })
        try {
            await this.repository.fetchUpdateSyaratJabatan(query).then((result) => {
                this.updaterequisiteChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.updaterequisiteChannel.next({ status: apiResponse.ERROR, data: error })
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    
    fetchDetailStankom = async (query) => {
        this.detailStankomChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchDetailStankom(query).then((result) => {
                this.detailStankomChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailStankomChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }

    fetchKompetensiList = async (query) => {
        this.kompetensiChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchKompetensiList(query).then((result) => {
                this.kompetensiChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.kompetensiChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed')
        }
    }
    fetchKompetensiLevel = async (query) => {
        this.kompetensiLevelChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchKompetensiLevel(query).then((result) => {
                this.kompetensiLevelChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.kompetensiLevelChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    
    fetchPositionInfo = async (query) => {
        this.positionInfoChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchPositionInfo(query).then((result) => {
                this.positionInfoChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.positionInfoChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchInfoJabatan = async (query) => {
        this.infoJabatanChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchInfoJabatan(query).then((result) => {
                this.infoJabatanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.infoJabatanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchPositionTask = async (query) => {
        this.detailTugasChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchPositionTask(query).then((result) => {
                this.detailTugasChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailTugasChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchResponsibility = async (query) => {
        this.detailTanggungjawabChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchResponsibility(query).then((result) => {
                this.detailTanggungjawabChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailTanggungjawabChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchAuthority = async (query) => {
        this.detailWewenangChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchAuthority(query).then((result) => {
                this.detailWewenangChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailWewenangChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchRequisite = async (query) => {
        this.detailPossesionRequisiteChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchRequisite(query).then((result) => {
                this.detailPossesionRequisiteChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailPossesionRequisiteChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchExperience = async (query) => {
        this.detailPengalamanChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchExperience(query).then((result) => {
                this.detailPengalamanChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailPengalamanChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchTraining = async (query) => {
        this.detailTrainingChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchTraining(query).then((result) => {
                this.detailTrainingChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailTrainingChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }
    fetchInterest = async (query) => {
        this.detailInterestChannel.next({status: apiResponse.LOADING})
        try {
            await this.repository.fetchInterest(query).then((result) => {
                this.detailInterestChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailInterestChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed' + error)
        }
    }

}

export default UpdateBloc
